module.exports = __webpack_public_path__ + "img/favorite-add.2413bf77.svg";